export default function Footer() {
  return (
    <footer className="bg-background-200 border-t border-background-300 pt-14 pb-8">
      <div className="px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10 pb-10 border-b border-background-300">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-play-circle-fill text-xl"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">色虎</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              色虎视频资源站提供视频、写真与图片资源，支持在线观看与主题筛选。以分类归档与更新记录的方式，帮助用户快速获取最新内容，满足日常浏览与收藏需求。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-foreground-950">内容导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <a href="#videos" className="text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer">
                  色虎视频
                </a>
              </li>
              <li>
                <a href="#photobooks" className="text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer">
                  色虎写真
                </a>
              </li>
              <li>
                <a href="#gallery" className="text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer">
                  色虎图片
                </a>
              </li>
              <li>
                <a href="#categories" className="text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer">
                  资源分类
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-foreground-950">帮助信息</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <a href="#guide" className="text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer">
                  浏览指南
                </a>
              </li>
              <li>
                <a href="#updates" className="text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer">
                  最新收录
                </a>
              </li>
              <li>
                <a href="#faq" className="text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer">
                  常见问题
                </a>
              </li>
              <li>
                <a href="#home" className="text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer">
                  返回顶部
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-500">
          <p>© 2026 色虎 · 视频与写真图片资源在线观看</p>
          <p>本站内容均为一般性资源整理说明，仅供浏览参考。</p>
        </div>
      </div>
    </footer>
  );
}